export const ARIMO_FONT_NAME = 'Arimo';
export const CINZEL_FONT_NAME = 'Cinzel';
export const CRIMSON_PRO_FONT_NAME = 'Crimson Pro';
export const DOSIS_FONT_NAME = 'Dosis';
export const INTER_FONT_NAME = 'Inter';
export const INTER_TIGHT_FONT_NAME = 'Inter Tight';
export const LATO_FONT_NAME = 'Lato';
export const LIBRE_BASKERVILLE_FONT_NAME = 'Libre Baskerville';
export const MERRIWEATHER_FONT_NAME = 'Merriweather'; // georgia
export const MONTSERRAT_FONT_NAME = 'Montserrat';
export const MULISH_FONT_NAME = 'Mulish';
export const NOTO_SANS_FONT_NAME = 'Noto Sans';
export const NUNITO_FONT_NAME = 'Nunito';
export const OPEN_SANS_FONT_NAME = 'Open Sans';
export const POPPINS_FONT_NAME = 'Poppins';
export const PT_SERIF_FONT_NAME = 'PT Serif';
export const RALEWAY_FONT_NAME = 'Raleway';
export const ROBOTO_FONT_NAME = 'Roboto';
export const ROKKITT_FONT_NAME = 'Rokkitt';
export const SIGNIKA_FONT_NAME = 'Signika'; // tahoma
export const SOURCE_SANS_3_FONT_NAME = 'Source Sans 3';
export const TINOS_FONT_NAME = 'Tinos'; // times new roman ish
export const WORK_SANS_FONT_NAME = 'Work Sans';

// DEPRECATED FONTS
export const DEPRECATED_SOURCE_SANS_PRO_FONT_NAME = 'Source Sans Pro';
export const DEPRECATED_CINSEL_FONT_NAME = 'Cinsel';
export const DEPRECATED_MULI_FONT_NAME = 'Muli';
export const DEPRECATED_LUSTRIA_FONT_NAME = 'Lustria';

export type ResumeFontName =
  | typeof ARIMO_FONT_NAME
  | typeof CINZEL_FONT_NAME
  | typeof CRIMSON_PRO_FONT_NAME
  | typeof DOSIS_FONT_NAME
  | typeof INTER_FONT_NAME
  | typeof INTER_TIGHT_FONT_NAME
  | typeof LATO_FONT_NAME
  | typeof LIBRE_BASKERVILLE_FONT_NAME
  | typeof MERRIWEATHER_FONT_NAME
  | typeof MONTSERRAT_FONT_NAME
  | typeof MULISH_FONT_NAME
  | typeof NOTO_SANS_FONT_NAME
  | typeof NUNITO_FONT_NAME
  | typeof OPEN_SANS_FONT_NAME
  | typeof POPPINS_FONT_NAME
  | typeof PT_SERIF_FONT_NAME
  | typeof RALEWAY_FONT_NAME
  | typeof ROBOTO_FONT_NAME
  | typeof ROKKITT_FONT_NAME
  | typeof SIGNIKA_FONT_NAME
  | typeof SOURCE_SANS_3_FONT_NAME
  | typeof TINOS_FONT_NAME
  | typeof WORK_SANS_FONT_NAME;

export type DeprecatedResumeFontName =
  | typeof DEPRECATED_MULI_FONT_NAME // goes to roboto
  | typeof DEPRECATED_CINSEL_FONT_NAME // goes to roboto
  | typeof DEPRECATED_SOURCE_SANS_PRO_FONT_NAME // goes to source sans 3
  | typeof DEPRECATED_LUSTRIA_FONT_NAME; // goes to self

// todo: add nunito sans when nextjs is upgraded
// don't include deprecated fonts here
// note order is reflected in the selector
const fontNames: ResumeFontName[] = [
  ROBOTO_FONT_NAME,
  OPEN_SANS_FONT_NAME,
  LATO_FONT_NAME,
  MONTSERRAT_FONT_NAME,
  PT_SERIF_FONT_NAME,
  NOTO_SANS_FONT_NAME,
  ARIMO_FONT_NAME,
  MERRIWEATHER_FONT_NAME,
  WORK_SANS_FONT_NAME,
  MULISH_FONT_NAME,
  SOURCE_SANS_3_FONT_NAME,
  CRIMSON_PRO_FONT_NAME,
  POPPINS_FONT_NAME,
  RALEWAY_FONT_NAME,
  LIBRE_BASKERVILLE_FONT_NAME,
  DOSIS_FONT_NAME,
  NUNITO_FONT_NAME,
  CINZEL_FONT_NAME,
  ROKKITT_FONT_NAME,
  SIGNIKA_FONT_NAME,
  TINOS_FONT_NAME,
  INTER_FONT_NAME,
  INTER_TIGHT_FONT_NAME,
];

export default fontNames;
